import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const adminSettingsApi = createApi({
  reducerPath: "adminSettingsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/api/admin/settings`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["AdminSettings"],
  endpoints: (builder) => ({
    getSettings: builder.query({
      query: (args = {}) => {
        const { page, limit, search, type } = args || {};
        const params = {};
        if (page !== undefined && page !== null) params.page = page;
        if (limit !== undefined && limit !== null) params.limit = limit;
        if (search) params.search = search;
        if (type) params.type = type;
        return { url: "", params };
      },
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: "AdminSettings", id })),
              { type: "AdminSettings", id: "PARTIAL-LIST" },
            ]
          : [{ type: "AdminSettings", id: "PARTIAL-LIST" }],
    }),

    getSettingById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (result, error, id) => [{ type: "AdminSettings", id }],
    }),

    createSetting: builder.mutation({
      query: (newSetting) => {
        const { settingTypeCode, settingDate, value, ...rest } = newSetting;

        const payload = {
          ...rest,
          // if type is "date", store in settingDate
          settingDate:
            settingTypeCode?.toLowerCase() === "date" && settingDate
              ? new Date(settingDate).toISOString()
              : null,
          // if not date, store in value
          value:
            settingTypeCode?.toLowerCase() === "date"
              ? ""
              : value?.toString() || "",
          createdAt: new Date().toISOString(),
        };

        return {
          url: "/",
          method: "POST",
          body: payload,
        };
      },
      invalidatesTags: [{ type: "AdminSettings", id: "PARTIAL-LIST" }],
    }),

    updateSetting: builder.mutation({
      query: ({ id, ...rest }) => {
        const { settingTypeCode, settingDate, value, ...remaining } = rest;

        const payload = {
          ...remaining,
          settingDate:
            settingTypeCode?.toLowerCase() === "date" && settingDate
              ? new Date(settingDate).toISOString()
              : null,
          value:
            settingTypeCode?.toLowerCase() === "date"
              ? ""
              : value?.toString() || "",
        };

        return {
          url: `/${id}`,
          method: "PUT",
          body: payload,
        };
      },
      invalidatesTags: (result, error, { id }) => [
        { type: "AdminSettings", id },
        { type: "AdminSettings", id: "PARTIAL-LIST" },
      ],
    }),

    deleteSetting: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "AdminSettings", id },
        { type: "AdminSettings", id: "PARTIAL-LIST" },
      ],
    }),
  }),
});

export const {
  useGetSettingsQuery,
  useGetSettingByIdQuery,
  useLazyGetSettingByIdQuery,
  useCreateSettingMutation,
  useUpdateSettingMutation,
  useDeleteSettingMutation,
} = adminSettingsApi;

export default adminSettingsApi;
export { adminSettingsApi };
